import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paginator: {
    marginBottom: theme.spacing(4),
  },
}));

export default useStyles;
